import React, { ReactNode } from "react";

import { DynamicLink } from "app/links/DynamicLink/DynamicLink";

import "./style.scss";

export interface SectionHeaderLinkProps {
    title: string;
    url: string;
    children?: ReactNode | ReactNode[];
}

function wrapFirstWord(text: string) {
    const parts: React.ReactNode[] = text.split(" ");
    const first = <span key="first">{parts.shift() as string}</span>;
    return [first, ` ${parts.join(" ")}`];
}

export const SectionHeaderLink = ({ title, url }: SectionHeaderLinkProps) => {
    const classNames = ["sectionHeaderLink"];

    return (
        <DynamicLink href={url} className={classNames.join(" ")}>
            {wrapFirstWord(title)}
        </DynamicLink>
    );
};
